import React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error } from '@progress/kendo-react-labels';
import { Switch } from '@progress/kendo-react-inputs';

/**
 * @deprecated Use /shared/components/formControls components instead.
 */
const FormToggle = fieldRenderProps => {
  const {
    validationMessage,
    visited,
    label,
    id,
    valid,
    disabled,
    optional,
    data = [],
    textField = 'name',
    dataItemKey = 'id',
    value,
    wrapperClassName,
    ...others
  } = fieldRenderProps;

  const showValidationMessage = visited && validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : '';

  return (
    <FieldWrapper className={wrapperClassName}>
      <div className='k-form-field-wrap'>
        <Label editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
          {label}
        </Label>
        <Switch onLabel='Yes' offLabel='No' valid={valid} id={id} disabled={disabled} ariaDescribedBy={errorId} checked={value} {...others} />
        {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
      </div>
    </FieldWrapper>
  );
};

export default FormToggle;
